/**
 * Pure decision logic for tearing down a live voice session in response to
 * realtime channel events (`channel.deleted`, self `channel.member_removed`).
 *
 * The realtime manager receives these events for EVERY channel in the tenant,
 * but only the session for the affected channel must be torn down — leaving an
 * unrelated live call would drop the agent mid-conversation. Keeping the
 * predicate pure (ids in → boolean out) makes the guard testable without
 * Zustand or a socket.
 */
export function shouldTearDownVoice(
  activeChannelId: string | null | undefined,
  eventChannelId: string | null | undefined,
): boolean {
  return !!activeChannelId && !!eventChannelId && activeChannelId === eventChannelId;
}
